import { FilterItem } from 'baby-ui/types'
import { camelCase } from 'lodash'
import { BRAND_INDEX, FEATURES_INDEX } from 'baby-ui/shared/constants'
import { SortOrder } from 'baby-ui/lib/SortOrder'
import { SORT_OPTIONS } from './EnhancedProductFilterWidget.constants'

type FilterItemModifier = (item: FilterItem) => FilterItem
type Product = APIResponse.HeroProduct

export const createCheckedItemLabelList = (filterItems: FilterItem[]) =>
  filterItems.filter(({ checked }) => checked).map(({ label }) => label)

export const createFilterItemState = (
  items: string[],
  modifier?: FilterItemModifier
) =>
  items.map((item) => {
    const value = {
      name: camelCase(item),
      label: item,
      checked: false,
    }

    if (modifier) {
      return modifier(value)
    }

    return value
  })

export const segmentFeatures = (features: string[]) => {
  const includedSegment = [] as string[]
  const featuresSegment = [] as string[]

  features.forEach((feature) => {
    const element = feature.toLowerCase()
    if (element === 'app' || element === 'bag included') {
      includedSegment.push(feature)
    } else {
      featuresSegment.push(feature)
    }
  })

  return { features: featuresSegment, included: includedSegment }
}

export const createFilterLabels = (products: Product[]) => {
  const featuresSet = new Set(products.map((p) => p[FEATURES_INDEX]).flat())
  const brandSet = new Set(products.map((p) => p[BRAND_INDEX]))
  const allUniqueBrandValues = Array.from(brandSet)
  const allUniqueFeatureValues = Array.from(featuresSet)

  return {
    ...segmentFeatures(allUniqueFeatureValues),
    brands: allUniqueBrandValues,
  }
}

export const sortItemsToManage = createFilterItemState(
  Object.keys(SORT_OPTIONS),
  (item) => {
    if (item.label === 'Lowest price') {
      return { ...item, checked: true }
    }

    return item
  }
)

export const getSumOfCheckedItems = (...filterItems: FilterItem[][]) => {
  let count = 0

  filterItems.forEach((items) => {
    const list = createCheckedItemLabelList(items)
    count += list.length
  })

  return count
}

export const getSortOrder = (label: keyof typeof SORT_OPTIONS) => {
  const { direction } = SORT_OPTIONS[label]
  if (direction === SortOrder.Desc) return 'DESC'
  return 'ASC'
}
